export default "__VITE_ASSET__BMyTcX5w__"